// src/components/AppShowreel.js

import React, { useState, useEffect } from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
import './AppShowreel.css';

const AppShowreel = () => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/data/apps.json')
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setApps(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch apps:', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Loading apps...</p>;
  }

  if (error) {
    return <p>Error loading apps: {error}</p>;
  }

  return (
    <section className="showreel">
      <h2 className="section-title">Featured Apps</h2>
      <div className="appsWrapper">
        {apps.map(app => (
          <div className="appCard" key={app.title}>
            <div className="appImageContainer">
              <img src={app.imagePath} alt={app.title} className="appImage" />
            </div>
            <div className="appDetails">
              <h3 className="appTitle">{app.title}</h3>
              <p className="appDescription">{app.description}</p>
              <div className="storeButtons">
                <a
                  href={app.appleStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="storeButton appleStore"
                  aria-label={`Download ${app.title} from the App Store`}
                >
                  <FaApple className="storeIcon" />
                  <span className="storeText">App Store</span>
                </a>
                <a
                  href={app.googleStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="storeButton googlePlay"
                  aria-label={`Download ${app.title} from Google Play`}
                >
                  <FaGooglePlay className="storeIcon" />
                  <span className="storeText">Google Play</span>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AppShowreel;